/**
 * Centralized API and environment configuration
 * Single source of truth for base URLs and third-party keys
 */

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.snappytweet.com'
    : 'http://localhost:4000');

export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '761031336103-deokl499c8q00uss3l7domralgqd5pmt.apps.googleusercontent.com';

export const API_ENDPOINTS = {
  // Twitter API
  TWEET: (id) => `${API_BASE_URL}/api/twitter/tweet/${id}`,
  THREAD: (id) => `${API_BASE_URL}/api/twitter/thread/${id}`,
  USER_PROFILE: (username) => `${API_BASE_URL}/api/twitter/user/${username}`,

  // Auth API
  LOGIN: `${API_BASE_URL}/api/auth/login`,
  REGISTER: `${API_BASE_URL}/api/auth/register`,
  VERIFY: `${API_BASE_URL}/api/auth/verify`,

  // Stripe API
  CREATE_CHECKOUT: `${API_BASE_URL}/api/stripe/create-session`,
  VERIFY_PAYMENT: `${API_BASE_URL}/api/stripe/verify`,
  LAST_SUBSCRIPTION: `${API_BASE_URL}/api/stripe/my-last-subscription`,
  PORTAL_SESSION: `${API_BASE_URL}/api/stripe/create-portal-session`,
  CANCEL_SUBSCRIPTION: `${API_BASE_URL}/api/stripe/cancel-subscription`,
  CHANGE_PLAN: `${API_BASE_URL}/api/stripe/change-plan`,

  // Analytics API
  EXPORT_EVENT: `${API_BASE_URL}/api/analytics/export-event`,

  // Admin API
  ADMIN_BASE: `${API_BASE_URL}/api/admin`,
  ADMIN_DASHBOARD: `${API_BASE_URL}/api/admin/dashboard-stats`,
};

const apiConfig = {
  API_BASE_URL,
  GOOGLE_CLIENT_ID,
  API_ENDPOINTS,
};

export default apiConfig;
